module.exports = __webpack_public_path__ + "static/img/64047B_R_3_20180321_LC.aa6602a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/64047B_R_3_20180321_LC.png
// module id = ti2O
// module chunks = 0